export default __webpack_public_path__ + "static/media/mibgate.489a021c.png";